import { render } from "./App.vue?vue&type=template&id=dba9ce54&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=dba9ce54&lang=css"

import exportComponent from "P:\\FTH\\Projekte\\Wegbier\\SVN\\trunk\\wegbier-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__